import { initAppInsights } from '../../config/appInsights';
import { env } from '../../env';

export const initMonitoring = (): void => {
  initAppInsights(
    env.VITE_APPLICATIONINSIGHTS_CONNECTION_STRING,
    env.VITE_DEPLOYMENT_ENV,
  );
};
